/*
 *
 * */

import { Input, InputMaskOptions } from '@/lib/formFactory/input';
export default class InputEntity {
    defaultValue: Input;
    entityName: string;
    entity: any;

    constructor(name: string) {
        this.defaultValue = {
            key: name,
            type: 'text',
            title: '',
            placeholder: '',
            autocomplete: '',
            value: '',
            required: false,
            size: 250,
            error: {
                class: '',
                message: '',
            },
            validation: {
                empty: 'Поле не заполнено',
                regex: '',
            },
            additional: '',
        };
        this.entityName = name;
        this.entity = { [this.entityName]: this.defaultValue };
    }

    setType(type: string) {
        this.entity[this.entityName]['type'] = type;
    }

    setTitle(title: string) {
        this.entity[this.entityName]['title'] = title;
    }

    setPlaceholder(placeholder: string) {
        this.entity[this.entityName]['placeholder'] = placeholder;
    }

    setRequired(required: boolean) {
        this.entity[this.entityName]['required'] = required;
    }

    setMask(mask: InputMaskOptions) {
        this.entity[this.entityName]['mask'] = {
            ...mask,
            showMaskOnHover: false,
        };
    }

    setValidation(validation: any) {
        this.entity[this.entityName]['validation'] = validation;
    }

    setSize(size: number) {
        this.entity[this.entityName]['size'] = size;
    }

    setAdditional(val: string|boolean) {
        this.entity[this.entityName]['additional'] = val;
    }

    setAutocomplete(type: string) {
        this.entity[this.entityName]['autocomplete'] = type;
    }
}

export const PHONE_MASK: InputMaskOptions = {
    // 9 means 'any number', 7 means '7'
    // but 7 counts as part of the mask, not the value
    mask: '+7-999-999-9999',
    // strip leading 7, since it's already in the mask
    onBeforeMask: (value) => {
        value = value.replace(/-/g, '')
        return value.length === 11 || value.startsWith('7') ? value.slice(1) : value;
    },
    // if there's a value, add a leading 7, since we need it in the model
    onUnMask: (_masked, unmasked) => unmasked && `7${unmasked}`,
}
